import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { useState } from 'react'

import Button from '@/components/button'
import { useAuth } from '@/hooks/use-auth'

import { useStyles } from './styles'

const LeaveModal = () => {
  const classes = useStyles()
  const { signOut } = useAuth()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        className={classes.openModalButton}
        labelOnly
        onClick={() => setOpen(true)}
      >
        <img src='assets/img/leave-icon.svg' alt='Ícone de saída' />
        <Typography>Sair</Typography>
      </Button>
      <Dialog
        classes={{ paper: classes.dialogMain }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>Sair da conta</DialogTitle>
        <DialogContent className={classes.content}>
          <Typography>Deseja sair da conta Atlas?</Typography>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button labelOnly onClick={() => setOpen(false)}>
            Voltar
          </Button>
          <Button onClick={signOut} outlined redBorder>
            Sair
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default LeaveModal
